import dayjs from "dayjs";

export const validate = (params) => {
    return params !== undefined && params !== null && params !== "";
};

export const convertDateWithValidation = (params) => {
    return validate(params) ? dayjs(params).format('DD/MM/YYYY') : "";
};

export const dateFormatterWithTime = (date) => {
    return validate(date) ? dayjs(date).format('DD/MM/YYYY HH:mm:ss') : "";
  }